import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  error: null,
  uploadProgress: 0,
  uploadStatus: "idle", // 'idle' | 'uploading' | 'success' | 'error'
};

const fileUploadSlice = createSlice({
  name: "fileUpload",
  initialState,
  reducers: {
    uploadStart: (state) => {
      state.isLoading = true;
      state.error = null;
      state.uploadStatus = "uploading";
    },
    uploadSuccess: (state) => {
      state.isLoading = false;
      state.uploadStatus = "success";
      state.uploadProgress = 100;
    },
    uploadFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.uploadStatus = "error";
    },
    updateProgress: (state, action) => {
      state.uploadProgress = action.payload;
    },
    resetUpload: (state) => {
      return initialState;
    },
  },
});

export const {
  uploadStart,
  uploadSuccess,
  uploadFailure,
  updateProgress,
  resetUpload,
} = fileUploadSlice.actions;
export default fileUploadSlice.reducer;
